import Api from '~/api'
import { resetForm, formSuccess, isLoading } from '~/form/actions'
import { push } from 'react-router-redux'
import { Map, List, fromJS } from 'immutable'

export function fetchUsers() {
  return async (dispatch, getState) => {
    try {
      if (getState().users.size) return null

      let res = await Api.get('/datatable?entity=user&sortBy=name&sortDir=asc')
      let { data = {} } = res || {}

      if (data.success) {
        dispatch(fetchUsersSuccess(data.items))
      } else {
        dispatch(fetchUsersError(data.message))
      }
    } catch (err) {
      console.log(err)
      dispatch(fetchUsersError(err.message || 'Error when creating project'))
    }
  }
}

export function fetchUsersSuccess(items) {
  return {
    type: 'USER_FETCH_SUCCESS',
    items,
  }
}

export function fetchUsersError(message) {
  return {
    type: 'USER_FETCH_ERROR',
    message,
  }
}
